import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const title = 'Custom Fields';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "custom-fields"
    }}>{`Custom Fields`}</h1>
    <p>{`You can always add any new field to reforml and freely use the attributes of new components`}</p>
    <h2 {...{
      "id": "example---integrate-the-popular-react-datepicker"
    }}>{`Example - integrate the popular react-datepicker`}</h2>
    <p>{`First you need to install react datepicker`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i react-datepicker
npm i react-datepicker @types/react-datepicker # for TypeScript
`}</code></pre>
    <p>{`Then you need to handle how to display the label, helperText, value, onChange on your own.`}</p>
    <p>{`To minimize redundancy of your code you may instead make a higher order component that wraps each of
your custom FieldComponent to display the label and helperText in the same format.`}</p>
    <p>{`Notice that react-datepicker uses selected to accept value, so we need to specifically assign value to its selected props.`}</p>
    <p>{`Since input components may accept `}<inlineCode parentName="p">{`value => void`}</inlineCode>{` or `}<inlineCode parentName="p">{`event => void`}</inlineCode>{` as onChange handler, reforml provides a `}<inlineCode parentName="p">{`generalizeOptionalValueCallback`}</inlineCode>{` helper function,
that help you to convert onChange props supplied to your component, which is a nullable `}<inlineCode parentName="p">{`value => void`}</inlineCode>{` function, into whatever handler that the input component accepts.
If the component gives the value, it will just call `}<inlineCode parentName="p">{`props.onChange(value)`}</inlineCode>{`; if it is an event, it will call `}<inlineCode parentName="p">{`props.onChange(event.target.value)`}</inlineCode></p>
    <p><inlineCode parentName="p">{`...props`}</inlineCode>{` basically passes rest of the settings to the `}<inlineCode parentName="p">{`ReactDatePicker`}</inlineCode>{`, so you can enjoy the different props that the datepicker provides`}</p>
    <p>{`(TypeScript only) `}<inlineCode parentName="p">{`FieldComponent<Date>`}</inlineCode>{` defines that this component handles value with type Date, as react-timepicker required.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React from 'react'
import ReactDatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import { FieldComponent, generalizeOptionalValueCallback } from 'reforml'

const DatePicker: FieldComponent<Date> = ({label, value, helperText, onChange, ...props}) => {
  return (
    <div>
      <div className='label'>{label}</div>
      <ReactDatePicker selected={value} onChange={generalizeOptionalValueCallback(onChange)} {...props}/>
      <div>
        <small className='form-text text-muted'>{helperText}</small>
      </div>
    </div>
  )
}

export default DatePicker
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-tsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [value, setValue] = useState({})
  const fields = useMemo(() => jsyaml.load(\`
  myField:
    type: date
    label: my field
    helperText: help
    defaultVal: \${Date.now()}
    showTimeSelect: true
  \`), [])
  return (
    <ReformlProvider fieldComponents={{ date: DatePicker }}>
      <BaseForm fields={fields} onChange={setValue} value={value}/>
      value:
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </ReformlProvider>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      